module.exports = __webpack_public_path__ + "img/login_bg.de356b6a.jpg";